import { memo } from 'react';

import { PrivateWorkspaceAgentPanelDescribeDock } from '~/components/v2/components/workspace/workspace-agent-panel/components/consent/form/PrivateWorkspaceAgentPanelDescribeDock';
import { PrivateWorkspaceAgentPanelFieldsDock } from '~/components/v2/components/workspace/workspace-agent-panel/components/consent/form/PrivateWorkspaceAgentPanelFieldsDock';
import { PrivateWorkspaceAgentPanelSearchDock } from '~/components/v2/components/workspace/workspace-agent-panel/components/consent/form/PrivateWorkspaceAgentPanelSearchDock';
import { PrivateWorkspaceAgentPanelStepperDock } from '~/components/v2/components/workspace/workspace-agent-panel/components/consent/form/PrivateWorkspaceAgentPanelStepperDock';
import { type AskFormElicitation } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/isAskFormElicitationEntry';

export type PrivateWorkspaceAgentPanelFormDockProps = {
  elicitation: AskFormElicitation;
};

export const PrivateWorkspaceAgentPanelFormDock = memo(({ elicitation }: PrivateWorkspaceAgentPanelFormDockProps) => {
  switch (elicitation.type) {
    case 'describe':
      return <PrivateWorkspaceAgentPanelDescribeDock elicitation={elicitation} />;
    case 'text_fields':
      return <PrivateWorkspaceAgentPanelFieldsDock elicitation={elicitation} />;
    case 'stepper':
      return <PrivateWorkspaceAgentPanelStepperDock elicitation={elicitation} />;
    case 'search_select':
      return <PrivateWorkspaceAgentPanelSearchDock elicitation={elicitation} />;
    default: {
      const unexpected: never = elicitation;

      return unexpected;
    }
  }
});

PrivateWorkspaceAgentPanelFormDock.displayName = 'PrivateWorkspaceAgentPanelFormDock';
